import axios from "axios";
import ElementUI from "element-ui";
import store from "@/store";
import logout from "@/utils/logout";
const request = axios.create({
	baseURL: "https://websitemanage.biggerlens.cn:18060",
	// baseURL: "http://192.168.31.181:18061",
	//测试地址
	// baseURL: "http://47.112.201.242:8091",
});

request.interceptors.request.use(
	(config) => {
		config.headers["Content-Type"] = "application/json;charset=utf-8";
		const token = store.getters['auth/token'];
		if (token) config.headers["token"] = token;
		return config;
	},
	(error) => {
		return Promise.reject(error);
	},
);

// response 拦截器

request.interceptors.response.use(
	(response) => {
		let res = response.data;
		// 如果是返回的文件
		if (response.config.responseType === "blob") {
			return res;
		}
		// 兼容服务端返回的字符串数据
		if (typeof res === "string") {
			res = res ? JSON.parse(res) : res;
		}
		//当权限验证不通过时候给出提示
		if (res.code === "401") {
			logout();
		}
		return res;
	},
	(error) => {
		return Promise.reject(error);
	},
);

export default request;
